export default __webpack_public_path__ + "static/media/13.ee9da384.jpg";